import { __assign } from 'tslib';
import React, { forwardRef } from 'react';
import { BaseToastPlate } from '../components/base-toast-plate/component.js';

var styles = {"actionSection":"toast-plate__actionSection_1r20s","title":"toast-plate__title_1r20s","closeButtonWrapper":"toast-plate__closeButtonWrapper_1r20s","closeButton":"toast-plate__closeButton_1r20s"};
require('./desktop.css')

var ToastPlateDesktop = forwardRef(function (restProps, ref) { return React.createElement(BaseToastPlate, __assign({}, restProps, { styles: styles, ref: ref })); });

export { ToastPlateDesktop };
